import { CHAT_FILE_ACCEPT_ATTR } from '../../common/chat/composer/fileValidation';
import { CHAT_IMAGE_ACCEPT_ATTR } from '../../common/chat/composer/chatImageCompatibility';
import { prefectures } from '../../../utils/prefectures';

export const BULK_LIMIT = 200;
export const MESSAGE_LIMIT = 5000;
export const EVENT_SEARCH_LIMIT = 80;
export const BULK_MESSAGE_ITEM_LIMIT = 5;
export const BULK_BATCH_MAX_FILE_SIZE_MB = 25;
export const BULK_BATCH_MAX_TOTAL_FILE_SIZE_MB = 80;
export const BULK_BATCH_MAX_FILE_SIZE_BYTES = BULK_BATCH_MAX_FILE_SIZE_MB * 1024 * 1024;
export const BULK_BATCH_MAX_TOTAL_FILE_SIZE_BYTES = BULK_BATCH_MAX_TOTAL_FILE_SIZE_MB * 1024 * 1024;
export const IMAGE_ACCEPT = CHAT_IMAGE_ACCEPT_ATTR;
export const FILE_ACCEPT = CHAT_FILE_ACCEPT_ATTR;
export const PREFECTURE_OPTIONS = (prefectures || [])
  .map((prefecture) => ({
    value: prefecture.value || prefecture.label || '',
    label: prefecture.label || prefecture.value || '',
  }))
  .filter((prefecture) => prefecture.value && prefecture.label);
export const PREFECTURE_SET = new Set(PREFECTURE_OPTIONS.map((prefecture) => prefecture.value));

const createDraftId = () => `${Date.now()}-${Math.random().toString(36).slice(2, 9)}`;

export const createBroadcastMessageDraft = (type = 'text') => ({
  id: createDraftId(),
  type,
  content: '',
  file: null,
});

export const parseNumeric = (value) => {
  const numberValue = Number.parseInt(String(value || '').trim(), 10);
  return Number.isFinite(numberValue) ? numberValue : null;
};

export const normalizeArtist = (row) => ({
  ...row,
  artist_id: String(row?.artist_id || ''),
  name: String(row?.name || ''),
  profile_picture: String(row?.profile_picture || ''),
  email: String(row?.email || ''),
  is_registered: typeof row?.is_registered === 'boolean' ? row.is_registered : Boolean(row?.email),
});

export const isPendingResponse = (item) => {
  const stage = String(item?.stage_status || '').toLowerCase();
  const hold = String(item?.hold_status || '').toLowerCase();
  const contract = String(item?.contract_status || '').toLowerCase();
  return stage === 'pending' || hold === 'pending' || contract === 'pending';
};

export const getGenderToneClass = (gender) => {
  const key = String(gender || '').toLowerCase();
  if (key === 'male' || key === 'man') return 'is-gender-male';
  if (key === 'female' || key === 'woman') return 'is-gender-female';
  if (key === 'secret') return 'is-gender-secret';
  return 'is-gender-unknown';
};

export const buildEventOptionLabel = (event) => {
  const eventDate = String(event?.event_date || '').trim() || '日付未設定';
  const eventName = String(event?.name || '').trim() || '（イベント名未設定）';
  const performanceType = String(event?.performance_type || '').trim();
  return performanceType ? `${eventDate} / ${eventName} ${performanceType}` : `${eventDate} / ${eventName}`;
};

export function appendBroadcastCastingParams(params, filter) {
  if (!filter.eventId) return;
  params.set('castingEventId', filter.eventId);
  params.set('castingKind', filter.kind);
  if (filter.status) params.set('castingStatus', filter.status);
}
